import { render } from "./SelectOffCat.vue?vue&type=template&id=594fb983&scoped=true"
import script from "./SelectOffCat.vue?vue&type=script&lang=js"
export * from "./SelectOffCat.vue?vue&type=script&lang=js"

import "./SelectOffCat.vue?vue&type=style&index=0&id=594fb983&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594fb983"]])

export default __exports__